'use client';

import type { Session } from 'next-auth';

/**
 * Previously warmed Spotlight by calling DANI at login. That path is retired
 * (M4S-5315) — Spotlight reads atlas.pdlc_insights_mine only. Kept as a
 * no-op so the private layout import stays stable.
 */
export function useDiscoverInsightsAutoRefresh(_session: Session | null) {
    // intentionally empty — do not call DANI or map-category on login
}
